import type { Repository } from '../../zero-schema.gen.ts'

export interface GitHubRepositoryOption {
  id: number
  full_name: string
  default_branch: string
  installationId: number
  lastUsedAt: number | null
}

export function githubRepositoriesFromZero(
  rows: readonly Repository[],
): GitHubRepositoryOption[] {
  return rows.map((row) => ({
    id: row.githubId,
    full_name: row.fullName,
    default_branch: row.defaultBranch ?? '',
    installationId: row.installationId,
    lastUsedAt: row.lastUsedAt ?? null,
  }))
}
